/** The lobby's camera and microphone preview: what a guest sees of
 * themselves before joining. Browser APIs only. In the room itself the
 * Chime session (src/chime.ts) takes the devices over. */
import { mediaErrorMessage } from "./meetings.js";

export class LocalMedia {
  stream: MediaStream | null = null;
  error: string | null = null;
  micOn = true;
  cameraOn: boolean;

  constructor(readonly video: boolean) {
    this.cameraOn = video;
  }

  /** Asks for the microphone (and the camera, when video is on). Never
   * throws: a refusal is kept in `error`, in words that say what to do. */
  async start(): Promise<void> {
    this.error = null;
    if (!navigator.mediaDevices?.getUserMedia) {
      this.error = mediaErrorMessage({ name: "SecurityError" });
      return;
    }
    try {
      this.stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: this.video });
      this.apply();
    } catch (err) {
      this.stream = null;
      this.error = mediaErrorMessage(err);
    }
  }

  setMic(on: boolean): void {
    this.micOn = on;
    this.apply();
  }

  setCamera(on: boolean): void {
    this.cameraOn = on && this.video;
    this.apply();
  }

  stop(): void {
    this.stream?.getTracks().forEach((t) => t.stop());
    this.stream = null;
  }

  private apply(): void {
    this.stream?.getAudioTracks().forEach((t) => (t.enabled = this.micOn));
    this.stream?.getVideoTracks().forEach((t) => (t.enabled = this.cameraOn));
  }
}
